import { BackendEnumFilterWebComponent } from './component/BackendEnumFilterWebComponent';

export { BackendEnumFilterWebComponent };
